import { render, staticRenderFns } from "./MyCoursesColorPicker.vue?vue&type=template&id=4a3dd8a6&"
import script from "./MyCoursesColorPicker.vue?vue&type=script&lang=js&"
export * from "./MyCoursesColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3dd8a6')) {
      api.createRecord('4a3dd8a6', component.options)
    } else {
      api.reload('4a3dd8a6', component.options)
    }
    module.hot.accept("./MyCoursesColorPicker.vue?vue&type=template&id=4a3dd8a6&", function () {
      api.rerender('4a3dd8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesColorPicker.vue"
export default component.exports